import { formatMoney } from '@sales-app/views/PotentialBooking/PotentialBooking/ActivitySection/RecommendedHomes/MapView/MapPopup/MapPopup.util'
import { formatInTimeZone } from 'date-fns-tz'

import { Appeasement } from '@/types/User'

export const AppeasementListColumns = [
  {
    Header: 'Date Created',
    accessor: 'createdAt',
    width: 60,
    Cell: function _Cell({ value = '' }: { value: string }) {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      try {
        const time = formatInTimeZone(value, timezone, 'MMM d, yyyy')
        return time
      } catch (e) {
        return 'Invalid  Date'
      }
    },
  },
  {
    Header: 'Amount',
    width: 60,
    Cell: function _Cell({ row }: { row: { original: Appeasement } }) {
      const { amount } = row.original

      return (
        <div className="flex w-fit-content flex-wrap items-baseline">
          <p className="font-bold text-black md:font-medium">{formatMoney(amount, false)}</p>
        </div>
      )
    },
  },
  {
    Header: 'Category',
    accessor: 'category',
    width: 50,
  },
  {
    Header: 'Reason',
    accessor: 'reason',
    width: 50,
  },
  {
    Header: 'Motivation',
    accessor: 'motivation',
    width: 50,
  },
  {
    Header: 'Status',
    accessor: 'status',
    width: 50,
  },
  {
    Header: 'Team',
    accessor: 'team',
    width: 50,
  },
]
